import { render, staticRenderFns } from "./DefaultChip.vue?vue&type=template&id=6759e056&"
import script from "./DefaultChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DefaultChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6759e056')) {
      api.createRecord('6759e056', component.options)
    } else {
      api.reload('6759e056', component.options)
    }
    module.hot.accept("./DefaultChip.vue?vue&type=template&id=6759e056&", function () {
      api.rerender('6759e056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/ChipsFilters/DefaultChip.vue"
export default component.exports